// extracted by mini-css-extract-plugin
export default {"drawer":"LegacyDrawer_drawer__U7Ci+","drawerBackdrop":"LegacyDrawer_drawerBackdrop__oV91f","right":"LegacyDrawer_right__GSa4F","left":"LegacyDrawer_left__fKxaa"};